import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Tariff } from '../tariff.model';
import { ModalService } from '../../../core/modal/modal.service';
import { TariffDescriptionModalComponent } from '../tariff-description-modal/tariff-description-modal.component';

@Component({
  selector: 'tax-tariff',
  templateUrl: './tariff.component.html',
  styleUrls: ['./tariff.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class TariffComponent {
  @Input() tariff?: Tariff;

  constructor(private modalService: ModalService) {}

  openTariffDescriptionModal(tariff: Tariff): void {
    this.modalService.openOld(TariffDescriptionModalComponent, {
      tariff,
    });
  }
}
